import commonconfig from 'commonconfig'

module.exports = {
  alipay: 1,  // for app
  wechat: 2,  // for app
  wechatWeb: 3, // wechat app
  alipayWeb: 4, // ali broswer
  alipayPCWeb: 5,
  wechatBrowser: 6, // wechat broswer
  cmbApp: 7, // 招行一网通
  weixinScan: 8,
  cmbPC: 9,
  weixinLittleApp: 10,
  huabeiWeb: 12,
  douli: 14,
  wesai: 16, // deprecated
  zhaohang: 20, // 招行
  nonghang: 24, // 农行
  fenqile: 25, // 分期乐
	pufabank: 27, // 浦发信用卡
  enjoyFirstPayLast: 98, // 支付宝芝麻先享后付
  moneyAccount: 99,
  noAmount: 100,
  wxmp: 141, // 微信小程序支付
  huifuWeapp: 163, // 汇付-微信支付
  huifuAlipay: 167, // 汇付-支付宝支付
  isEnabled: function (type) {
    return new Promise(function (resolve, reject) {
      commonconfig
        .get()
        .then(function (config) {
          var paymentTypes = config.paymentTypes
          var hasType = paymentTypes.indexOf(type) != -1
          resolve(hasType)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/mods/payment-types.js